<template>
  <div id="us-states">
    <b-input-group id="state-abbrev-input-group">
      <b-input-group-prepend>
        <b-dropdown :text="choice.abbr || 'Abbreviation'" no-flip boundary="state-abbrev-input-group">
          <div form-class="abbrDropdown bd-links">
            <b-dropdown-item v-for="state in states.states" :key="state['abbr']" @click="choice = state;">{{state['abbr']}}</b-dropdown-item>
          </div>
        </b-dropdown>
      </b-input-group-prepend>
      <b-form-input v-model="val" required id="state-abbrev-input"></b-form-input>
    </b-input-group>
    <ul ref="dropdown" id="input-dropdown" v-if="showDropdown">
      <li class="suggestion" v-for="item in suggestions" @click="choice = item">{{item.title}}</li>
    </ul>
  </div>
</template>

<script>
import { BFormInput, BDropdown, BDropdownItem, BInputGroup, BInputGroupPrepend, BDropdownForm } from 'bootstrap-vue'
import states from '../../lib/usStates'
import helpers from '../../lib/helpers'
export default {
  name: "UsStates",
  components: {
    BFormInput,
    BDropdown,
    BDropdownItem,
    BInputGroup, 
    BInputGroupPrepend,
    BDropdownForm
  },
  props:{
    attr: {type: String, default: 'abbr'},
    value: {type: String},
  },
  created(){
    this.debouncedSuggestions = helpers.debounce(this.getSuggestions, 0)
  },
  mounted(){
    let state = this.findState(this.value)
    if (state){
      this.choice = state
    }

    let self = this;
    document.body.addEventListener('click', function (event) {
      if (document.getElementById('us-states') !== null) {
        if (!document.getElementById('us-states').contains(event.target)) {
          self.suggestions = [];
        }
      }
    });
  },
  data(){
    return {
      val: '',
      states,
      choice: {},
      suggestions: [],
    }
  },
  computed:{
    showDropdown(){
      return this.suggestions.length > 0
    }
  },
  watch:{
    choice(newv){
      let newv2 = newv
      this.val = newv2.title
      this.suggestions = []
      this.$emit('input', newv2[this.attr])

    },
    val(newv){
      if (newv){
        let state = this.findState(newv)
        if (state){
          this.choice = state
        } else {
          this.getSuggestions(newv)
        }
      }
      else {
        this.suggestions = [];
      }
    },
    value(newv){
      let state = this.findState(newv)
      if (state){
        this.choice = state
        return
      }
      this.val = newv
    },
  },
  methods:{
    getSuggestions(newv){
      if (this.states.lowers.includes(newv) || this.states.titles.includes(newv)){
        this.suggestions = []
      }else{
        this.suggestions = this.states.search(newv)
      }
    },
    findState(newv){
      for (let state of this.states.states){
        if (state.abbr === newv || state.title === newv || state.lower === newv){
          return state
        }
      }
    },
  }
//.dropdown-toggle{
}
</script>
<style scoped>
  #search-input >>> .dropdown-toggle{
    background: #eeeeee;
  }
  #state-dropdown >>> ul{
    margin-top: 0;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    width: 100%;
    text-align: center;
  }

  #search-input{
    padding-bottom: 0;
    margin-bottom: 0;
  }
  #input-dropdown{
    position: absolute;
    background: white;
    z-index: 1000;
    border: #0d0d0d 1px solid;
    border-top: none;
    padding-top: 0;
    margin-top: 0;
    width: 90%;
    padding-left: 0;
    padding-right: 6px;
    border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em;
    border-color: #80bdff;
  }
  .suggestion{
    list-style-type: none;
    cursor: pointer;
    width: 100%;
    padding-top: 1%;
    padding-left: 5%;
    color: #0290AE;
    background-color: transparent;
  }

  .suggestion:hover {
    color: #02738b;
    background-color: #f8f9fa;
  }

</style>



// WEBPACK FOOTER //
// UsStates.vue?5c3be0a0